<template>
    <base-form-control v-bind="formControlAttributes">
        <slot name="prepend"></slot>

        <v-select
            class="control"
            :class="actionBtnClasses"
            v-bind="controlAttributes"
            :clearable="clearable"
            v-model="model"
            :disabled="disabled"
            :multiple="multiple"
            v-on="listeners"
            :options="filteredOptions"
        ></v-select>

        <slot name="append"></slot>
    </base-form-control>
</template>

<script>
import BaseInput from './BaseInput';
import VueSelectCommons from './VueSelectCommons';

export default {
    name: 'form-select',
    extends: BaseInput,
    mixins: [VueSelectCommons],
    data () {
        return {
            model: ''
        };
    },
    props: {
        options: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    computed: {
        filteredOptions () {
            // Only apply this customization for multiple selection
            if (!this.multiple) {
                return this.options;
            }
            // Get selected options from v-model
            const selectedOptions = Array.isArray(this.model)
                ? this.model
                : [];
            if (selectedOptions.length === 0) {
                return this.options;
            }
            // Check whether an option is already selected
            return this.options.filter(option => {
                return !selectedOptions.some(selected => {
                    return this.isSameOption(option, selected);
                });
            });
        }
    },
    mounted () {
        this.findModel();
    },
    methods: {
        isSameOption (option, selected) {
            // Handle primitive options
            if (
                option === null ||
                selected === null ||
                typeof option !== 'object' ||
                typeof selected !== 'object'
            ) {
                return option === selected;
            }
            // Handle options like { label: 'Bull A', value: 1 }
            if (
                option.value !== undefined &&
                selected.value !== undefined
            ) {
                return option.value === selected.value;
            }
            // Handle options like { id: 1, label: 'Bull A' }
            if (
                option.id !== undefined &&
                selected.id !== undefined
            ) {
                return option.id === selected.id;
            }
            // Fallback for options without value or id
            return option.label === selected.label;
        }
    }
};
</script>
